import { memo, useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";

import { Modal } from "shared/ui/Modal";
import { HStack, VStack } from "components/landingNew/shared/ui/Stack";
import { Icon } from "components/landingNew/shared/ui/Icon";
import { ReactComponent as CloseIcon } from "static/img/ic-close.svg";
import { Text } from "components/landingNew/shared/ui/Text";
import { Button } from "shared/ui/Button";
import { showAlert } from "redux/actions/setAppActions";

import cls from "./SociometryAnnulResultModal.module.scss";
import { classNames } from "shared/lib/classNames/classNames";

interface SociometryAnnulResultModalProps {
    className?: string;
    isOpen: boolean;
    onClose: () => void;
    sessionId: string;
    pupilId: string;
    onAnnulled?: () => void;
}

export const SociometryAnnulResultModal = memo((props: SociometryAnnulResultModalProps) => {
    const { className, isOpen, onClose, sessionId, pupilId, onAnnulled } = props;
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);

    const deleteHandler = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        e.preventDefault();

        try {
            setIsLoading(true);
            await axios.delete(`sociometry/psych/session/${sessionId}/pupil/${pupilId}/result`);
            onAnnulled?.();
            onClose();
        } catch (error: any) {
            const message =
                error.response?.data?.error?.message || error.response?.data?.message || "Не удалось удалить результат";
            dispatch(showAlert({ type: "error", text: message }));
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal
            className={classNames(cls.sociometryAnnulResultModal, {}, [className])}
            isOpen={isOpen}
            onClose={onClose}
            lazy
            overlay
        >
            <div
                className={cls.closeButton}
                onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                    e.stopPropagation();
                    onClose();
                }}
            >
                <Icon Svg={CloseIcon} />
            </div>
            <VStack justify="center" gap={24}>
                <Text text="Вы действительно хотите удалить результат?" size="l" align="center" />
                <VStack max gap={32}>
                    <Text text="Будет удалён результат только этого ученика. Тест будет назначен ему снова." size="m" />
                    <HStack max justify="end" gap={20}>
                        <Button
                            onClick={(e) => {
                                e.stopPropagation();
                                onClose();
                            }}
                            variant="outline"
                            size="medium"
                            disabled={isLoading}
                        >
                            Отмена
                        </Button>
                        <Button onClick={deleteHandler} color="red" isLoading={isLoading} size="medium">
                            Удалить
                        </Button>
                    </HStack>
                </VStack>
            </VStack>
        </Modal>
    );
});

SociometryAnnulResultModal.displayName = "SociometryAnnulResultModal";
